import { render, staticRenderFns } from "./DropFileCDC.vue?vue&type=template&id=c7424c48&scoped=true"
import script from "./DropFileCDC.vue?vue&type=script&lang=js"
export * from "./DropFileCDC.vue?vue&type=script&lang=js"
import style0 from "./DropFileCDC.vue?vue&type=style&index=0&id=c7424c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7424c48",
  null
  
)

export default component.exports